import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { ProjectType_Entity } from "../../entities/projectType";
import { filmsApi } from "../api/filmsApi";

const projectTypesAdapter = createEntityAdapter<ProjectType_Entity>();
const initialState = projectTypesAdapter.getInitialState();

export const projectTypeEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getProjectTypes: build.query<EntityState<ProjectType_Entity>, void>({
      query: () => `projectTypes`,
      transformResponse: (responseData: ProjectType_Entity[]) => {
        return projectTypesAdapter.setAll(initialState, responseData);
      },
      providesTags: ["projectTypes"],
    }),
    getProjectType: build.query<ProjectType_Entity, number>({
      query: (id) => `projectTypes/${id}`,
      providesTags: (result, error, id) => [{ type: "projectTypes", id }],
    }),
    createProjectType: build.mutation<
      ProjectType_Entity,
      Partial<ProjectType_Entity>
    >({
      query: (body) => ({
        method: "POST",
        body,
        url: `projectTypes`,
      }),
      invalidatesTags: ["projectTypes"],
    }),
    updateProjectType: build.mutation<
      void,
      { id: number; body: Partial<ProjectType_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `projectTypes/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "projectTypes", id },
        "projectTypes",
      ],
    }),
    deleteProjectType: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `projectTypes/${id}`,
      }),
      invalidatesTags: ["projectTypes"],
    }),
  }),
});

export const {
  useGetProjectTypeQuery,
  useGetProjectTypesQuery,
  useCreateProjectTypeMutation,
  useDeleteProjectTypeMutation,
  useUpdateProjectTypeMutation,
} = projectTypeEndpoints;

export default projectTypeEndpoints;
